module.exports = __webpack_public_path__ + "static/img/joinus.3f18a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/joinus.jpg
// module id = 4fMK
// module chunks = 1